import type { AgentConfig } from "~/shared/types";

import AgentIcon from "./AgentIcon.vue";
import Icon from "./Icon.vue";

const config: AgentConfig = {
  name: "Codegen",
  icon: Icon,
  agentIcon: AgentIcon,
  color: "#2c00ef",
  helpUrl: "https://help.dartai.com/en/articles/11618601-ai-coding-agent",
  configFields: [
    {
      key: "orgId",
      type: "text",
      label: "Org ID",
      placeholder: "Your Codegen org ID",
    },
    {
      key: "apiKey",
      type: "password",
      label: "API token",
      placeholder: "Your Codegen API token",
    },
  ],
};

export default config;
